import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeContextService} from "../../../commons/services/date-range-context.service";
import {Expense} from "../../models/expenses.model";
import {ExpenseStatus} from "../../types/expenses-status.type";
import {ExpenseQueryRequest} from "../../models/expense-query-request.model";
import {ExpensesExportQueryRequest} from "../../models/expenses-export-query-request.model";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {ExpensesAlerts} from "../../services/expenses-alerts.service";
import {ExpensesDialogService} from "../../services/expenses-dialog.service";
import {ExpensesService} from "../../services/expenses-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ExpensesHttpService} from "../../services/expenses-http-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {finalize} from "rxjs";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";
import {ExpensesCompressAttachmentsToZipRequest} from "../../models/expenses-compress-attachments-to-zip-request.model";

export class ExpensesViewComponent implements IController {

  enableFilterByAgent: boolean;
  enableFilterByCarrier: boolean;
  accountIds: string[];
  agentIds: string[]
  categoryIds: string[]
  statuses: string[]
  serviceId: string[]
  from: any;
  to: any;
  query: string;

  public loadLimit: number;
  public expensesRef: any;

  public filtersConfig: any;
  public blockingSearchDatesRangeLimit: number;

  public excludeMode: boolean = false;
  public selectedIds: any = [];
  public selectedKeys: any = {};

  public availableActionsMap: { approve: boolean, decline: boolean, export: boolean, bulkDownloadAttachments: boolean };
  public selectedExpenseIdTimeLine :string;

  private isTimeSelectionDisabled: any;
  private siteId: string;
  private infiniteScroll: any;
  private accountsRef: any;

  constructor(private $expenses, private $accounts: $accountsFactory, private splitService, private $infiniteScroll, private $state, private moment, private $log,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private confirmDialogService: ConfirmDialogService, private dateRangeContextService: DateRangeContextService, private expensesService: ExpensesService, private expensesDialogService: ExpensesDialogService, private expensesAlerts: ExpensesAlerts,
              private expensesHttpService: ExpensesHttpService, private bringozLoaderService: BringozLoaderService, private bringozToastService: BringozToastService) {
    this.blockingSearchDatesRangeLimit = this.splitService.getBlockingSearchDatesRangeLimit();

    this.accountsRef = this.$accounts();
  }

  $onInit() {
    this.availableActionsMap = {approve: false, decline: false, export: false, bulkDownloadAttachments: false}
    this.siteId = this.splitService.getSiteId();
    this.loadLimit = 30;
    this.expensesRef = this.$expenses();
    this.selectedKeys = {};
    this.selectedExpenseIdTimeLine = undefined;

    this.isTimeSelectionDisabled = false;
    this.filtersConfig = {
      bringozFilters: {
        accountIds: this.accountIds,
        agentIds: this.agentIds,
        categoryIds: this.categoryIds,
        statuses: this.statuses,//List<ExpenseStatus> statuses,
      },
      queryString: this.query,
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today(),
      rangeLimit: {
        min: !this.blockingSearchDatesRangeLimit ? undefined : this.moment().subtract(this.blockingSearchDatesRangeLimit, 'day').startOf('day').valueOf(),
        max: undefined,
      },
      limit: this.loadLimit,
      settings: this.splitService.getSiteExpensesSettings(this.splitService.getSiteId())
    }

    const dateStart = this.moment(this.from).format("MM/DD/YYYY"),
      dateEnd = this.moment(this.to).format("MM/DD/YYYY");

    this.isTimeSelectionDisabled = !_.isEqual(dateStart, dateEnd);

    this.expensesRef.$query(this._getQuery());
    this.infiniteScroll = this.$infiniteScroll(this.expensesRef, this.loadLimit, {getFullData: true});


    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });


  }

  submitQuery(queryString) {
    this.filtersConfig.queryString = queryString;
    this._reloadExpenses();
    this._setStateParams();
  }

  onRangeChanged(range) {
    if (range) {
      const dateStart = this.moment(range.dateStart).format("MM/DD/YYYY"),
        dateEnd = this.moment(range.dateEnd).format("MM/DD/YYYY");

      // Disable TIME picker if it's not the same date.
      this.isTimeSelectionDisabled = !_.isEqual(dateStart, dateEnd);
      this.dateRangeContextService.setRange(range.dateStart, range.dateEnd);
    }
    this._changeRange(range);
    this._setStateParams();
  }


  onAgentIdsChanged(selectedIds) {
    _.set(this.filtersConfig, 'bringozFilters.agentIds', selectedIds);
    this._reloadExpenses();
    this._setStateParams();
  }

  onExpensesCategoriesIdsChanged(selectedIds) {
    _.set(this.filtersConfig, 'bringozFilters.categoryIds', selectedIds);
    this._reloadExpenses();
    this._setStateParams();
  }

  onExpensesStatusesChanged(selectedIds) {
    _.set(this.filtersConfig, 'bringozFilters.statuses', selectedIds);
    this._reloadExpenses();
    this._setStateParams();
  }


  onCarriersIdChanged(selectedIds) {
    _.set(this.filtersConfig, 'bringozFilters.accountIds', selectedIds);
    _.set(this.filtersConfig, 'bringozFilters.agentIds', []);

    this._reloadExpenses();
    this._setStateParams();
  }

  //////////////////////////// ACTIONS and BULK ACTIONS ////////////////////////////
  onOpenActions($mdMenu) {
    this.availableActionsMap = {approve: true, decline: true, export: true, bulkDownloadAttachments: true}

    if (!this.excludeMode && !this.selectedIds.length) {
      this.availableActionsMap = {approve: false, decline: false, export: false, bulkDownloadAttachments: false}
    } else if (!this.excludeMode && this.selectedIds.length) {
      this.expensesRef.$asyncValues(this.selectedIds)
        .then((expenses) => {
          _.forEach(expenses, (ex: Expense) => {
            if (ex.expenseStatus !== ExpenseStatus.PENDING) {
              this.availableActionsMap.approve = false;
              this.availableActionsMap.decline = false;
            }
          })
        })
        .catch((error) => {
          this.availableActionsMap = {approve: false, decline: false, export: false, bulkDownloadAttachments: false}
          this.selectedIds.length > 1 ? this.expensesAlerts.getMultipleError() : this.expensesAlerts.getOneError()
        })
        .finally(() => {
          $mdMenu.open();
          return;
        })
    }
    $mdMenu.open();
  }


  onApproveAndCreateCommissions(selectedIds, event) {
    const expenseQueryRequest: ExpenseQueryRequest = this._setExpenseQueryRequest(selectedIds)
    this._approveExpenses(expenseQueryRequest);

  }

  onApproveExpenseNoBulk(selectedIds, event) {
    this._approveExpenses({expenseIds: selectedIds});
  }

  onDeclineExpenses(selectedIds, event) {
    const expenseQueryRequest: ExpenseQueryRequest = this._setExpenseQueryRequest(selectedIds)
    this._declineExpenses(expenseQueryRequest);
  }

  onDeclineExpenseNoBulk(selectedIds, event) {
    this._declineExpenses({expenseIds: selectedIds});
  }

  onExportExpenses() {
    const expensesExportQueryRequest: ExpensesExportQueryRequest = {
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      zoneId: this.splitService.getTimeZone(),
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      carrierIds: this.filtersConfig.bringozFilters.accountIds,
      categoryIds: this.filtersConfig.bringozFilters.categoryIds,
      statuses: this.filtersConfig.bringozFilters.statuses,
    }

    this.expensesService.exportExpenses(expensesExportQueryRequest)
  }

  onExpensesDownloadClicked(expense: Expense) {
    const fileName = `[${expense.agentReference.fullName}] - [${expense.serviceId}].zip`
    this.onBulkCompressExpensesAttachments([expense.id], fileName);
  }

  onBulkCompressExpensesAttachments(selectedIds: string[], fileName?: string) {
    const params: ExpensesCompressAttachmentsToZipRequest = {
      ids: selectedIds,
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      categoryIds: this.filtersConfig.bringozFilters.categoryIds,
      statuses: this.filtersConfig.bringozFilters.statuses,
      zoneId: this.splitService.getTimeZone()
    };

    this.bringozToastService.info({
      body: "EXPENSES_ATTACHMENTS_COMPRESS_PROCESSING"
    });
    this.bringozLoaderService.on();
    this.expensesHttpService.compressToZip(params)
      .pipe(finalize(() => this.bringozLoaderService.off()))
      .subscribe(response => {
        if(response && response.size < 100) {
          this.bringozToastService.warning({
            body: "EXPENSES_ATTACHMENTS_COMPRESS_NO_DATA_FOUND"
          });
          return;
        }
        const blob = new Blob([response], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName ?? 'Expenses.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
  }

  onCreateNewExpense(event) {
    //TODO Louay ben
  }

  onEditExpense(expense, event) {
    this.expensesDialogService.editExpense(expense, event)
      .then((expense) => {
        this._updateExpense(expense);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to edit expense', error);
        } else {
          this.$log.debug('Dialog Closed');
        }
      })
  }

  onDeleteExpense(expense, event) {
    const text = 'Are you sure you want to delete this expense?';
    this.confirmDialogService.confirm('Delete Working Slot', text, event)
      .then(() => {
        this._deleteExpense(expense.id);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  onSelectExpensesChanged(selectedIds, excludeMode) {
    this.selectedIds = selectedIds;
    this.excludeMode = excludeMode;
  }

  onViewSettingsChange(settings) {
    const oldSettingsRef = angular.copy(this.filtersConfig.settings);

    this.filtersConfig.settings = settings;
    this.splitService.setSiteExpensesSettings(settings);
  }

  onTimeLineClicked(expenseId){
    this.selectedExpenseIdTimeLine = expenseId;
  }

  onCloseTimeLine(){
    this.selectedExpenseIdTimeLine = undefined;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _changeRange(range) {
    if (!_.isUndefined(range) && (!_.isEqual(range.dateStart, this.filtersConfig.range.dateStart) || !_.isEqual(range.dateEnd, this.filtersConfig.range.dateEnd))) {
      this.filtersConfig.range = range;
      this._reloadExpenses();
      this._setStateParams();
    }
  }

  private _reloadExpenses() {
    this.selectedExpenseIdTimeLine = undefined;

    this.expensesRef.$query(this._getQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQuery() {
    return {
      categoryIds: this.filtersConfig.bringozFilters.categoryIds,
      statuses: this.filtersConfig.bringozFilters.statuses,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      query: this.filtersConfig.queryString,
      limit: this.loadLimit,
    };
  }

  private _updateExpense(expense) {
    this.expensesService.updateExpense(expense)
      .then((expense) => {
        this._reloadExpenses();
      })
  }


  private _setStateParams() {
    this.$state.go('.', this._getQuery(), {notify: false, reload: false});
  }

  private _approveExpenses(expenseQueryRequest: ExpenseQueryRequest) {
    this.expensesService.approveExpenses(expenseQueryRequest)
      .then((expenses) => {
        this._reloadExpenses();
      })
  }

  private _declineExpenses(expenseQueryRequest: ExpenseQueryRequest) {
    this.expensesService.declineExpenses(expenseQueryRequest)
      .then((expenses) => {
        this._reloadExpenses();
      })
  }

  private _setExpenseQueryRequest(selectedIds): ExpenseQueryRequest {

    return this.excludeMode ? {
      excludedExpenseIds: selectedIds,
      categoryIds: this.filtersConfig.bringozFilters.categoryIds,
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      searchTerm: this.filtersConfig.queryString
    } : {expenseIds: selectedIds}
  }

  private _deleteExpense(expenseId) {
    this.expensesService.deleteExpenses([expenseId])
      .then((expenses) => {
        this._reloadExpenses();
      })
  }

}

angular
  .module('bringoz.admin.expenses')
  .component('expensesView', {
    bindings: {
      enableFilterByAgent: '<?',
      enableFilterByCarrier: '<?',
      accountIds: '<?',
      agentIds: '<?',
      categoryIds: '<?',
      statuses: '<?',
      serviceId: '<?',
      from: '<?',
      to: '<?',
      query: '<?',
    },
    template: require('./expenses-view.html').default,
    controller: ExpensesViewComponent
  });

